// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `td {
  white-space: nowrap;
}

tr:nth-child(1) td:nth-child(1) {
  border-top-left-radius: 0.5em;
}

tr:nth-last-child(1) td:nth-child(1) {
  border-bottom-left-radius: 0.5em;
  border-bottom: none;
}

tr:nth-child(1) td:nth-last-child(1) {
  border-top-right-radius: 0.5em;
}

tr:nth-last-child(1) td:nth-last-child(1) {
  border-bottom-right-radius: 0.5em;
  border-bottom: none;
}

@media only screen and (max-width: 600px) {
  /* For mobile phones: */
  tr {
    font-size: 8px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/last-opposition/last-opposition.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;;AACA;EAEI,6BAAA;AACJ;;AAEA;EAEI,gCAAA;EACA,mBAAA;AAAJ;;AAGA;EAEI,8BAAA;AADJ;;AAIA;EAEI,iCAAA;EACA,mBAAA;AAFJ;;AAKA;EAEI,uBAAA;EACA;IACI,yBAAA;EAHN;AACF","sourcesContent":["td {\r\n    white-space: nowrap;\r\n}\r\ntr:nth-child(1) td:nth-child(1) {\r\n    // border: 5px  solid violet!important;\r\n    border-top-left-radius: 0.5em;\r\n}\r\n\r\ntr:nth-last-child(1) td:nth-child(1) {\r\n    // border: 5px  solid violet!important;\r\n    border-bottom-left-radius: 0.5em;\r\n    border-bottom: none;\r\n}\r\n\r\ntr:nth-child(1) td:nth-last-child(1) {\r\n    // border: 5px  solid violet!important;\r\n    border-top-right-radius: 0.5em;\r\n}\r\n\r\ntr:nth-last-child(1) td:nth-last-child(1) {\r\n    // border: 5px  solid violet!important;\r\n    border-bottom-right-radius: 0.5em;\r\n    border-bottom: none;\r\n}\r\n\r\n@media only screen and (max-width: 600px) {\r\n\r\n    /* For mobile phones: */\r\n    tr {\r\n        font-size: 8px !important;\r\n    }\r\n    \r\n\r\n\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
